import { Community, UNKNOWN_COMMUNITY } from "@/types/community";

export enum CollaborationStatus {
  COLLABORATION_STATUS_EMAILED = 1,
  COLLABORATION_STATUS_ACTIVE = 2,
  COLLABORATION_STATUS_EXPIRED = 3,
  COLLABORATION_STATUS_CANCELED = 4,
};

export interface Collaboration {
  uniqueid: string,
  collabstatus: number,
  exclusive: boolean,
  expires: string,
  rabbl_community1: Community,
  rabbl_community2: Community,
}

export const UNKNOWN_COLLABORATION : Collaboration = {
  uniqueid: "unknown",
  collabstatus: -1,
  exclusive: false,
  expires: "unknown",
  rabbl_community1: UNKNOWN_COMMUNITY,
  rabbl_community2: UNKNOWN_COMMUNITY,
};
